<template>

  <div>

      <el-row>
        <el-col :sm="24" :md="24">
          <h3>Average Rental</h3>
          <pie-chart :data="chart"
          :donut="true"
          thousands=","
          legend="right"
          :download="true"
          :colors="colours" />
        </el-col>

        <el-col :sm="24" :md="24">
          <h3>Total Sites</h3>
          <pie-chart :data="chart2"
          :donut="true"
          thousands=","
          legend="left"
          :colors="colours"
          :download="true" />
        </el-col>
      </el-row>

      <div v-if="showDetails">
        <hr />

        <el-table
           :data="landowners"
           border
           stripe
           show-summary
           :summary-method="summaryFormatter"
           style="width: 100%">

           <el-table-column prop="owner"
           width="400"
            label="Owner">
           </el-table-column>

           <el-table-column prop="sites"
           label="Sites"
            sortable
            align="right"
            :formatter="formatInt">
           </el-table-column>

           <el-table-column
              prop="totalDeposit"
              label="Total Deposit"
              sortable
              align="right"
              :formatter="formatNum">
           </el-table-column>

           <el-table-column
              prop="avgValue"
              label="Avg. Rental"
              sortable
              align="right"
              :formatter="formatNum">
           </el-table-column>
         </el-table>

      </div>

</div>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import ElTableMixins from '@/mixins/ElTableMixins'

import {chartColors} from '@/components/Data'

export default {
  mixins: [PostMixins, ElTableMixins],

  props: {
    showDetails: {
      type: Boolean,
      default: false
    }
  },


  methods: {
    landownerData (data) {
      this.landowners = data

      if (this.landowners && this.landowners.length > 0) {

        for (var i = 0; i < this.landowners.length; i++) {
          this.chart.push([this.landowners[i].owner, Number(Number(this.landowners[i].avgValue).toFixed(2))])
          this.chart2.push([this.landowners[i].owner, Number(this.landowners[i].sites)])
        }
      }
    },

    summaryFormatter (params) {
      let sums = this.totalColumns(params, 'Totals', ['sites'], null, ['avgValue', 'totalDeposit'])

      for (var i = 0; i < sums.length; i++) {
        if (i > 0) {
          sums[i] = (i > 0 && i === 1 ? this.formatInteger(sums[i]) : this.formatNumber(sums[i]))
        }
      }

      return sums
    }

  },

  data () {
    return {
      landowners: [],
      chart: [],
      chart2: [],
      colours: chartColors
    }
  },

  created () {
    this.fetchData('report/property', this.landownerData, 'Property stats')
  }
}
</script>
